export function RogersDashboardService($http, apexApiUrl) {
    'ngInject';
    return {
        retrieveRogersDailyProductionReport: retrieveRogersDailyProductionReport,
        retrieveRogersEmployeesTsuReport: retrieveRogersEmployeesTsuReport,
        retrieveRogersOwnersTsuReport: retrieveRogersOwnersTsuReport,
        retrieveRogersTrendReports: retrieveRogersTrendReports,
        retrieveRogersSlippageSummaryReport: retrieveRogersSlippageSummaryReport,
        retrieveRogersSlippageReport: retrieveRogersSlippageReport,
        retrieveRogersRecruitingBonusReport: retrieveRogersRecruitingBonusReport,
        retrieveRogersRecruitingBonusBreakdownReport: retrieveRogersRecruitingBonusBreakdownReport
    };

    function retrieveRogersDailyProductionReport(query) {
        return $http({
            method: "GET",
            params: query,
            url: apexApiUrl + "dashboards/rogers/daily-production-report"
        }).then(function (response) {
            return response.data;
        });
    }

    function retrieveRogersEmployeesTsuReport(query) {
        return $http({
            method: "GET",
            params: query,
            url: apexApiUrl + "dashboards/rogers/employees-tsu-report"
        }).then(function (response) {
            return response.data;
        });
    }

    function retrieveRogersOwnersTsuReport(query) {
        return $http({
            method: "GET",
            params: query,
            url: apexApiUrl + "dashboards/rogers/owners-tsu-report"
        }).then(function (response) {
            return response.data;
        });
    }

    function retrieveRogersTrendReports(query) {
        return $http({
            method: "GET",
            params: query,
            url: apexApiUrl + "dashboards/rogers/rogers-trend-report"
        }).then(function (response) {
            return response.data;
        });
    }

    function retrieveRogersSlippageReport(query) {
        return $http({
            method: "GET",
            params: query,
            url: apexApiUrl + "dashboards/rogers/rogers-slippage-report"
        }).then(function (response) {
            return response.data;
        });
    }

    function retrieveRogersSlippageSummaryReport(query) {
        return $http({
            method: "GET",
            params: query,
            url: apexApiUrl + "dashboards/rogers/rogers-slippage-summary-report"
        }).then(function (response) {
            return response.data;
        });
    }

    function retrieveRogersRecruitingBonusReport(query) {
        return $http({
            method: "GET",
            params: query,
            url: apexApiUrl + "dashboards/rogers/rogers-recruiting-bonus-report"
        }).then(function (response) {
            return response.data;
        });
    }

    function retrieveRogersRecruitingBonusBreakdownReport(query) {
        return $http({
            method: "GET",
            params: query,
            url: apexApiUrl + "dashboards/rogers/rogers-recruiting-bonus-breakdown-report"
        }).then(function (response) {
            return response.data;
        });
    }
}
